import React from 'react';
import classNames from 'classnames/bind';
import { DataBlocks, I18n } from 'components';

import styles from '../../styles.pcss';

const cx = classNames.bind(styles);
export const UnavailableBlock = () => (
  <DataBlocks.Container className={cx('page')}>
    <DataBlocks.Block title={<I18n path="internet.internet.blockTitle" />}>
      <I18n path="internet.internet.unavailableForYourRegionText" />
    </DataBlocks.Block>
  </DataBlocks.Container>
);
